import React from 'react';

import { Loader } from '@eika/loader';

interface CenteredLoaderProps {
    text?: string | undefined;
}

const CenteredLoader = ({ text }: CenteredLoaderProps) => {
    if (text) {
        return (
            <div className="centered-loader">
                <Loader />
                <p>{text}</p>
            </div>
        );
    }

    return (
        <div className="centered-loader">
            <Loader />
        </div>
    );
};

export default CenteredLoader;
